$(document).ready(function() {
    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 500,
        arrows: false,
        adaptiveHeight: true,
        autoplay: true,
        fade: true,
        dots: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    adaptiveHeight: false,
                    dots: true
                }
            }
        ]
    });
    $('.slider-for').on('afterChange', function(event, slick, current){
        $('.press-logo .slider-nav > div').removeClass('active');
        $('.press-logo .slider-nav > div[data-slide="'+ current +'"]').addClass('active');
    });
    $('.press-logo .slider-nav > div').on('click', function () {
        var index = $(this).data('slide');
        $('.press-logo .slider-nav > div').removeClass('active');
        $(this).addClass('active');
        $('.slider-for').slick('slickGoTo', index);
    });
})
